module.exports = __webpack_public_path__ + "static/media/educate.3332050c.png";